import { TrackingActions } from "../actions/TrackingActions";
import { notify } from "../uidispatcherapi/Notifications";

import type { NotificationHandle } from "uidispatcher_api/UidispatcherApiModule";
import type { ReactNode } from "react";

export type IntlNotification = {
	type: "server-error" | "user-error" | "warning" | "info" | "success";
	text: ReactNode;
	id: string;
	dismissable?: boolean;
};
export class NotificationsImpl {
	send: (arg0: IntlNotification) => NotificationHandle = notifyIntl;
}
export const Notifications = new NotificationsImpl();
export function notifyIntl(data: IntlNotification): NotificationHandle {
	if (!notify) {
		return {
			dismiss: () => undefined,
		};
	}

	TrackingActions.trackNotificationShown(data);
	return notify({
		type: data.type,
		id: data.id,
		dismissable: data.dismissable,
		text: data.text,
	});
}
